import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function hostReportError(err) {
  _setTimeout(function () {
    throw err;
  }, 0);
}